/* Crochuito – v6 finishing layer: cart page checkout bar and entrance, thread in page intros,
   account steps that play on phones. Works with assets/crochuito.js and assets/crochuito-pages.js. */
(function () {
  'use strict';
  if (window.CSPlus) return;
  var d = document, de = d.documentElement, w = window;
  var reduce = w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(w.Shopify && w.Shopify.designMode);
  var desk = w.matchMedia('(min-width: 990px)');
  var hasIO = 'IntersectionObserver' in w;

  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }

  /* ---------- cart page: the entrance plays once, the checkout bar follows the summary ---------- */
  var mbarIO = null;
  function initCartPage() {
    var page = d.querySelector('.cs-cb--page');
    if (!page) return;
    if (!reduce && !design && !de.classList.contains('cs-cart-entered')) {
      de.classList.add('cs-cart-enter', 'cs-cart-entered');
      setTimeout(function () { de.classList.remove('cs-cart-enter'); }, 1800);
    }
    bindBar();
  }
  function bindBar() {
    if (mbarIO) { mbarIO.disconnect(); mbarIO = null; }
    var bar = d.querySelector('.cs-cb--page [data-cs-cart-mbar]');
    var target = d.querySelector('.cs-cb--page [data-cs-cart-checkout]');
    if (!bar || !target) return;
    function set(on) {
      bar.classList.toggle('is-visible', on);
      bar.inert = !on;
      if (on) bar.removeAttribute('aria-hidden'); else bar.setAttribute('aria-hidden', 'true');
    }
    set(false);
    if (!hasIO) return;
    // the bar only exists below 990px (CSS); it shows whenever the real checkout button is out of view
    mbarIO = new IntersectionObserver(function (es) {
      set(!es[0].isIntersecting);
    }, { threshold: 0 });
    mbarIO.observe(target);
  }
  d.addEventListener('cs:cart-swapped', bindBar);

  /* ---------- page intro: the thread is stitched while the intro scrolls away ---------- */
  var threads = [], ticking = false;
  // the stroke does not scale with the drawing (vector-effect), so dashes are measured in screen pixels
  function measureThread(t) {
    var m = t.path.getScreenCTM ? t.path.getScreenCTM() : null;
    var s = m ? Math.sqrt(m.a * m.a + m.b * m.b) : 1;
    t.len = Math.ceil(t.total * (s || 1)) + 2;
    t.path.style.strokeDasharray = t.len + ' ' + t.len;
    t.top = t.svg.getBoundingClientRect().top + w.scrollY;
  }
  function initThreads(scope) {
    $$('[data-cs-thread]', scope).forEach(function (svg) {
      if (svg._th) return;
      var path = svg.querySelector('path');
      if (!path || !path.getTotalLength) return;
      svg._th = 1;
      var total = path.getTotalLength();
      var knot = svg.querySelector('.cs-thread__knot');
      if (knot && path.getPointAtLength) {
        var end = path.getPointAtLength(total);
        knot.setAttribute('cx', end.x.toFixed(1));
        knot.setAttribute('cy', end.y.toFixed(1));
      }
      if (reduce || design) { path.style.strokeDasharray = 'none'; svg.classList.add('is-done'); return; }
      var t = { svg: svg, path: path, total: total, len: 0, shown: 0, top: 0 };
      measureThread(t);
      path.style.strokeDashoffset = String(t.len);
      threads.push(t);
      // a first stitch right after load; from then on the scroll pulls the thread through
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          path.style.transition = 'stroke-dashoffset 1.6s cubic-bezier(.2, .7, .2, 1)';
          update();
          setTimeout(function () { path.style.transition = ''; svg.classList.add('is-ready'); }, 1650);
        });
      });
    });
  }
  function update() {
    ticking = false;
    var vh = w.innerHeight, y = w.scrollY;
    threads.forEach(function (t) {
      var span = Math.max(160, t.top - vh * 0.15);
      var p = Math.max(t.shown, 0.42 + 0.58 * clamp(y / span, 0, 1)); // stitches stay when scrolling back
      t.shown = p;
      t.path.style.strokeDashoffset = (t.len * (1 - p)).toFixed(1);
      t.svg.classList.toggle('is-done', p > 0.985);
    });
  }
  function tick() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }

  /* ---------- account steps: on phones the illustration plays step by step while in view ---------- */
  function initAutoplay(scope) {
    $$('[data-cs-autoplay]', scope).forEach(function (sec) {
      if (sec._ap) return;
      sec._ap = 1;
      var steps = $$('[data-cs-scrolly-step]', sec);
      if (steps.length < 2 || typeof sec._activate !== 'function') return;
      var i = 0, timer = 0, visible = false;
      function go(k) { i = (k + steps.length) % steps.length; sec._activate(i); }
      function stop() { clearInterval(timer); timer = 0; }
      function start() {
        stop();
        if (desk.matches || reduce || design || !visible) return;
        timer = setInterval(function () { go(i + 1); }, 4200);
      }
      steps.forEach(function (s, k) {
        s.addEventListener('click', function () { if (desk.matches) return; go(k); start(); });
      });
      if (hasIO) new IntersectionObserver(function (es) {
        visible = es[0].isIntersecting;
        if (visible) start(); else stop();
      }, { threshold: 0.35 }).observe(sec);
      var onChange = function () { if (desk.matches) stop(); else start(); };
      if (desk.addEventListener) desk.addEventListener('change', onChange); else if (desk.addListener) desk.addListener(onChange);
    });
  }

  /* ---------- boot ---------- */
  function init(scope) {
    scope = scope || d;
    initThreads(scope);
    initAutoplay(scope);
  }
  function boot() { init(d); initCartPage(); }
  w.CSPlus = { refresh: init };
  w.addEventListener('scroll', tick, { passive: true });
  w.addEventListener('resize', function () { threads.forEach(function (t) { measureThread(t); t.path.style.strokeDashoffset = (t.len * (1 - t.shown)).toFixed(1); }); tick(); });
  d.addEventListener('shopify:section:load', function (e) { init(e.target); initCartPage(); });
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
